import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
// import { CornerDownLeft } from "react-feather";
import { all_routes } from "../router/all_routes";
import { useSelector, useDispatch } from "react-redux";
import { passwordReset } from "../../core/data/redux/action";
import { AppDispatch, RootState } from "../../core/data/redux/store";
import { useForm, SubmitHandler } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const routes = all_routes;

type FormValues = {
  email: string;
};

const ForgotPassword = () => {

  //  const [isToggle, setIsToggle] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { user, success, error } = useSelector(
    (state: RootState) => ({
      success: state.auth.success,
      user: state.auth.user,
      error: state.auth.error,
    })
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormValues>({
    defaultValues: {
      email: "",
    },
  });

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    dispatch(passwordReset(data));
  };

  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');

  useEffect(() => {
    if (success) {
      showToast(success);
      navigate(routes.login);
      reset();
      // dispatch(resetAuth());
    } else if (error) {
      showToast(error);
      // dispatch(resetAuth());
      // reset();
    }
  }, [user, error]);



  const showToast = (message: any) => {
    setToastClass((error) ? 'bg-danger text-white' : 'bg-success text-white')

    setToastMessage(message);
  };


  const handleCloseToast = () => {
    setToastMessage('');

  };


  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      } else {
        toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      }

    }
  }, [toastMessage, toastClass]);

  return (
    <>
      <div className="main-wrapper login-body">
        {/* Header */}
        <header className="log-header">
          <Link to={routes.homeOne}>
            <ImageWithBasePath
              className="img-fluid logo-dark"
              src="assets/img/logo/fairRentallogo.png"
              alt="Logo"
            />
          </Link>
        </header>

        {/* {toastMessage && (
          <>
            {toastClass === 'bg-danger text-white'
              ? toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
              : toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })}
            <ToastContainer autoClose={3000} />
          </>
        )} */}

        <ToastContainer autoClose={3000} />

        {/* /Header */}
        <div className="login-wrapper">
          <div className="loginbox">
            <div className="login-auth">
              <div className="login-auth-wrap">
                <div className="sign-group">
                  <Link to={routes.homeOne} className="border-0 text-primary-dark d-flex align-items-center">

                    <i className="bx bx-arrow-back fs-5 me-2"></i>

                    <span className="mt-1"> Back To Home </span>
                  </Link>
                </div>
                <h1>Forgot Password</h1>
                <p className="account-subtitle">
                  Enter your email and we will send you a link to reset your
                  password.
                </p>
                <form onSubmit={handleSubmit(onSubmit)}>


                  <div className="input-block">
                    <label className="form-label">
                      Email Address <span className="text-danger">*</span>
                    </label>
                    <input type="email" className="form-control" {...register("email", { required: "Email is required" })} />
                    {errors.email && <p className="text-danger">{errors.email.message}</p>}
                  </div>



                  <button type="submit" className="btn btn-primary w-100 btn-size">Forget Password</button>


                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <footer className="log-footer">
          <div className="container-fluid">
            {/* Copyright */}
            <div className="copyright">
              <div className="copyright-text">
                <p>© 2025 FaiRental. All Rights Reserved.</p>
              </div>
            </div>
            {/* /Copyright */}
          </div>
        </footer>
        {/* /Footer */}
      </div>
    </>
  );
};

export default ForgotPassword;
